import { useState, useCallback } from 'react';

/**
 * Hook to manage sequential dialogs instead of nested ones
 * Avoids z-index stacking issues by showing one dialog at a time
 */
export const useSequentialDialogs = () => {
  const [dialogStack, setDialogStack] = useState([]);
  const [currentDialog, setCurrentDialog] = useState(null);

  const openDialog = useCallback((dialogConfig) => {
    setDialogStack(prev => [...prev, currentDialog].filter(Boolean));
    setCurrentDialog(dialogConfig);
  }, [currentDialog]);

  const closeDialog = useCallback(() => {
    const previousDialog = dialogStack[dialogStack.length - 1];
    if (previousDialog) {
      setDialogStack(prev => prev.slice(0, -1));
      setCurrentDialog(previousDialog);
    } else {
      setCurrentDialog(null);
    }
  }, [dialogStack]);

  const closeAllDialogs = useCallback(() => {
    setDialogStack([]);
    setCurrentDialog(null);
  }, []);

  const replaceDialog = useCallback((dialogConfig) => {
    setCurrentDialog(dialogConfig);
  }, []);

  return {
    currentDialog,
    openDialog,
    closeDialog,
    closeAllDialogs,
    replaceDialog,
    hasDialogs: currentDialog !== null
  };
};

export default useSequentialDialogs;
